import React, { PropsWithChildren } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { TokenTransferToken } from "../..";
import {
  TokenTransferRequestBody,
  TokenTransferResponseBody,
  TokenTransferStatusResponseBody,
} from "../hooks/types";
import { TokenTransferRequestFieldNames } from "../hooks/constants";
import usePostTokenTransfer from "../hooks/usePostTokenTransfer";

type FormData = TokenTransferRequestBody & TokenTransferStatusResponseBody;

type TokenTransferFormProps = PropsWithChildren<{
  token: TokenTransferToken;
  onSubmit?: (data?: any) => void;
  onSuccess: (data: TokenTransferResponseBody) => void;
  onError?: (e?: any) => void;
}>;

export default function TokenTransferForm({
  children,
  onSubmit,
  token,
  onSuccess,
  onError,
}: TokenTransferFormProps) {
  const methods = useForm<FormData>({
    mode: "onChange",
    defaultValues: {
      [TokenTransferRequestFieldNames.walletAddress]: "",
      [TokenTransferRequestFieldNames.legalAgreement]: false,
    },
  });

  const initTokenTransfer = usePostTokenTransfer({
    contractAddress: token.contractAddress as string,
    tokenId: token.id as string,
  });

  const { handleSubmit, setError } = methods;

  const handleError = () => {
    setError("root", { message: "form submission error" });
  };

  const submitHandler = async (data: Omit<FormData, "status">) => {
    onSubmit && onSubmit(data);

    try {
      initTokenTransfer.mutate(
        { ...data },
        {
          onSuccess: (data) => onSuccess && onSuccess(data),
          onError: (e) => {
            handleError();
            onError && onError(e);
          },
        },
      );
    } catch (error) {
      handleError();
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submitHandler)}>{children}</form>
    </FormProvider>
  );
}
